import React from "react";
import estilo from "../styles/Titulos.module.css";
import { Link } from "react-router-dom";

function Titulos({ titulo, tipo }) {
  return (
    <div className={estilo.titulo}>
      <h2>{titulo}</h2>
      <div className={estilo.ver}>
        <Link to={`/${tipo}`}>
          <p>Ver más...</p>
        </Link>
        <svg width="25" height="25" fill="currentColor" viewBox="0 0 16 16">
          <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z" />
        </svg>
      </div>
    </div>
  );
}

export default Titulos;
